import Badge from "@/v2-ui/badge"
import type { PublicIncidentSummary } from "@/v2-status-client/status/status.types"

export type StatusIncidentBadgeProps = {
  state: PublicIncidentSummary["state"]
}

// "Ongoing" / "Resolved" pill on each incident row. v2-ui Badge
// gives us the chrome (rounded, outline, padding) for free; the
// state mapping lives here so the row component stays trivial.
function StatusIncidentBadge(props: Readonly<StatusIncidentBadgeProps>) {
  if (props.state === "ongoing") {
    return (
      <Badge variant="warning" size="sm" pill>
        Ongoing
      </Badge>
    )
  }
  return (
    <Badge variant="outline" size="sm" pill>
      Resolved
    </Badge>
  )
}

export default StatusIncidentBadge
